import { render, staticRenderFns } from "./ACLAvatarList.vue?vue&type=template&id=03994c0e&"
import script from "./ACLAvatarList.vue?vue&type=script&lang=js&"
export * from "./ACLAvatarList.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports